import {Utils} from '@/common/scripts/utils';

const CLASS_ACTIVE = 'is-active';

class InfoPoint {
    private point: HTMLElement;
    private active: boolean = false;
    private clicked: boolean = false;

    public constructor(point: HTMLElement) {
        this.point = point;
        this.active = false;
        this.clicked = false;

        this._clickOutside = this._clickOutside.bind(this);
    }

    public init(): void {
        if (this.point.dataset['init'] === 'true') {
            return;
        }

        this.point.dataset['init'] = 'true';

        this._bindEvents();
    }

    close(): void {
        document.removeEventListener('click', this._clickOutside);

        this.point.classList.remove(CLASS_ACTIVE);
    }

    private _bindEvents(): void {
        this.point.addEventListener('click', this._pointState.bind(this));
        this.point.addEventListener('mouseover', this._pointState.bind(this));
        this.point.addEventListener('mouseout', this._pointState.bind(this));
    }

    private _pointState(event: MouseEvent): void {
        const target: EventTarget | null = event.target;
        const type: string = event.type;

        if (target instanceof HTMLElement) {
            // Если на поинт уже раскрыт и на него навели - то ничего не делаем
            // Расскрытый по клику поинт - закрываем только по клику
            if (type === 'click' && Utils.isMobile()) {
                this.clicked = !this.clicked;
                this.point.classList.contains(CLASS_ACTIVE) ? this.close() : this._open();
            } else if (type !== 'click' && !Utils.isMobile()) {
                if (type === 'mouseover') {
                    this._open();
                } else if (type === 'mouseout') {
                    this.close();
                }
            }
        }
    }

    private _open(): void {
        document.addEventListener('click', this._clickOutside);

        this.point.classList.add(CLASS_ACTIVE);
    }

    /**
     * Ловит клик снаружи элемента
     * @param {object} event - объект события клика
     * @private
     */
    private _clickOutside(event: Event): void {
        if (!event?.target) {
            return;
        }

        const target: HTMLElement = event.target as HTMLElement;

        if (!target.closest('.j-info-point')?.isEqualNode(this.point)) {
            this.close();
        }
    }
}

export default InfoPoint;
